import { switchMap, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { authActions } from '@content-platform/web-angular-shared-util-auth';
import { GraphApi } from '../services';
import { getAdalId } from '../user-profile-helpers';
import { LoadCurrentUserSuccess } from '../actions/ad-user.actions';

/**
 * The Graph Api effects imported in {@link GraphApiModule}.
 *
 * @export
 * @class GraphApiEffects
 */
@Injectable()
export class GraphApiEffects {
  constructor(private actions: Actions, private api: GraphApi) {}

  /**
   * Listens to the LOGIN_SUCCESS action to get the graph api token, this token takes a little longer so it's best
   * to retrieve it right after user login succeeds.
   */
  @Effect()
  loginSuccess: Observable<Action> = this.actions.pipe(
    ofType(authActions.LOGIN_SUCCESS),
    map((action: authActions.LoginSuccess) => action.payload),
    switchMap(adUser => {
      return adUser.profile?.permissionToken
      ? of(new LoadCurrentUserSuccess(adUser.profile))
      : this.api
            .getFullUserDetails(getAdalId(adUser))
            .pipe(map(user => new LoadCurrentUserSuccess(user)));
    })
  );
}
